import React from 'react';
import { ContentRow } from '../../../types/homepage';

interface MiscBlockProps {
    row: ContentRow;
    onVideoClick?: (videoId: string) => void;
}

export const VerticalList: React.FC<MiscBlockProps> = ({ row, onVideoClick }) => {
    const { content, title, settings } = row;
    if (!content || content.length === 0) return null;

    return (
        <section className='py-8 px-4 sm:px-6 lg:px-8' style={{ backgroundColor: settings?.backgroundColor as string }}>
            <div className='max-w-4xl mx-auto'>
                {title && (
                    <h2 className='text-3xl font-bold mb-6' style={{ color: settings?.textColor as string }}>{title}</h2>
                )}
                <div className='space-y-4'>
                    {content.map((video: any) => (
                        <div key={video.id} onClick={() => onVideoClick?.(video.id)} className='flex gap-4 p-4 hover:bg-gray-50 rounded-lg cursor-pointer transition'>
                            <img src={video.thumbnail} alt={video.title} className='w-40 h-24 object-cover rounded' />
                            <div className='flex-1'>
                                <h3 className='font-bold mb-1 line-clamp-2'>{video.title}</h3>
                                <p className='text-sm text-gray-600 line-clamp-2'>{video.description}</p>
                                <div className='flex gap-3 mt-2 text-xs text-gray-500'>
                                    {video.views && <span>{video.views.toLocaleString()} views</span>}
                                    {video.duration && <span>{video.duration}</span>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export const HorizontalScroll: React.FC<MiscBlockProps> = ({ row, onVideoClick }) => {
    const { content, title, settings } = row;
    if (!content || content.length === 0) return null;

    return (
        <section className='py-8 px-4 sm:px-6 lg:px-8' style={{ backgroundColor: settings?.backgroundColor as string }}>
            <div className='max-w-7xl mx-auto'>
                {title && (
                    <h2 className='text-3xl font-bold mb-6' style={{ color: settings?.textColor as string }}>{title}</h2>
                )}
                <div className='flex gap-4 overflow-x-auto pb-4 scrollbar-hide'>
                    {content.map((video: any) => (
                        <div key={video.id} onClick={() => onVideoClick?.(video.id)} className='flex-none w-48 cursor-pointer group'>
                            <div className='relative aspect-square bg-gray-200 rounded-lg overflow-hidden mb-2'>
                                <img src={video.thumbnail} alt={video.title} className='w-full h-full object-cover group-hover:scale-105 transition' />
                            </div>
                            <h3 className='text-sm font-semibold line-clamp-2'>{video.title}</h3>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

